import { Tag } from "@msuite/ui/tag";
import { getColorByString } from "@msuite/utils/colors";
import { moment } from "@msuite/utils/date";
import type { TagesschauNewsItem, TagesschauTextContent } from "@msuite/utils/types";

/** Props Interface */
interface CommandNewsCardProps {
	news: TagesschauNewsItem;
}

export function CommandNewsCard({ news }: CommandNewsCardProps) {
	const teaserSrc = news.teaserImage?.imageVariants["16x9-256"];

	/** Render */
	return (
		<div className="v-stack card gap-1.5 last:border-b-0 break-inside-avoid">
			{/* Meta row */}
			<div className="h-stack items-center justify-between gap-2">
				<div className="h-stack items-center gap-1.5">
					{news.breakingNews && (
						<Tag
							size="xs"
							color="red"
							withPing
							transform="uppercase"
						>
							Breaking
						</Tag>
					)}
					<p className="text-xs font-semibold uppercase text-secondary tracking-wide">
						{news.topline || news.ressort}
					</p>
				</div>
				<p className="text-xs text-secondary shrink-0">{moment(news.date).longFormat()}</p>
			</div>

			{/* Title + thumbnail */}
			<div className="h-stack justify-between items-stretch gap-12">
				<div className="flex-1 v-stack">
					<p className="heading leading-snug">{news.title}</p>
					{news.content
						?.filter((item): item is TagesschauTextContent => item.type === "text")
						.slice(0, 3)
						.map((item, i) => (
							<p
								key={i}
								className="text-sm label leading-relaxed opacity-75 text-justify"
								// biome-ignore lint: i trust tagesschau
								dangerouslySetInnerHTML={{ __html: item.value }}
							/>
						))}
					<div className="flex-1" />
					{news.tags.length > 0 && (
						<div className="h-stack items-center justify-between gap-2">
							<div className="h-stack items-center gap-3 flex-wrap">
								{news.tags.slice(0, 3).map((t) => (
									<Tag
										key={t.tag}
										size="xs"
										color={getColorByString(t.tag)}
										variant="plain"
									>
										{t.tag}
									</Tag>
								))}
							</div>
						</div>
					)}
				</div>
				{teaserSrc && (
					<img
						src={teaserSrc}
						alt={news.teaserImage.alttext}
						className="rounded shrink-0 object-cover aspect-video"
						style={{ width: "25%" }}
					/>
				)}
			</div>
		</div>
	);
}
